'use strict';

// TODO @andre --- remove

var _ = require('lodash');

var MapUtil = function () {

  function MapUtil (config) {

    if (!config) {
      throw new Error('Missing required parameter: config');
    }

    this._config = config;
  }

  MapUtil.prototype.getConfig = function () {
    return this._config;
  };

  MapUtil.prototype.getBaseLayers = function (location) {
    location = location || {};

    return {
      mapbox: this._getTileLayer('mapbox', null, {
        maxZoom: location.maxNativeZoom || 19,
        maxNativeZoom: location.maxNativeZoom || 19
      })
    };
  };

  MapUtil.prototype.getTileLayers = function (layers, type, location) {
    var _this = this;

    return _.reduce(layers, function (layers, layer) {
      var params = {
        layerId: layer.layerData,
        maxZoom: location.zoom || 21,
        bounds: location.bounds
      };


      layer = _this._getTileLayer(type, params.layerId.toString(), params);
      layer.$show(); // make the layer visible by default
      layers[layer.name] = layer;
      return layers;
    }, {});
  };

  MapUtil.prototype.getMapDefaults = function () {
    var config = this._config;
    return config.mapDefaults;
  };

  MapUtil.prototype.getEvents = function () {
    var config = this._config;
    return config.events;
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Private Helpers
  /////////////////////////////////////////////////////////////////////////////////////////////////

  MapUtil.prototype._getTileLayer = function (type, id, options) {
    var config = this._config;

    if (!config.tileLayers) {
      throw new Error('No "tileLayers" are defined');
    }

    var layer = _.clone(config.tileLayers[type], true);

    layer.name = id || layer.name;
    layer.layerOptions = layer.layerOptions || {};

    if (options) {
      _.extend(layer.layerOptions, options);
    }

    layer.$show = function (show) {
      show = show !== undefined ? show : true;
      layer.visible = show;
    };

    return layer;
  };

  return {
    create: function (config) {
      return new MapUtil(config);
    }
  };
};

module.exports = MapUtil;


// WEBPACK FOOTER //
// ./src/common/utils/MapUtil.js